import { createReducer } from '@reduxjs/toolkit'
import { ICourse } from 'shared/types'
import { receiveLibraryCourses } from 'model/actions'

const initialState = null as Record<string, ICourse> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveLibraryCourses, (state, action) => action.payload)
})

export default reducer
